exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--white-color:#fff;--white-light-color:hsla(0,0%,100%,.5);--black-color:#000;--black-light-color:rgba(0,0,0,.5);--light-color:#8bf5ff;--light-light-color:rgba(139,245,255,.5);--primary-color:#4fc2f7;--primary-light-color:rgba(79,194,247,.5);--dark-color:#0092c4;--dark-light-color:rgba(0,146,196,.5)}main{margin-top:20%;position:relative;overflow:auto}main.main1{height:45vh}main.main2{height:70vh}.cursor-pointer-disabled{cursor:not-allowed}.custom-file-input:lang(en)~.custom-file-label:after{content:\"Browse\"}.custom-file-input:lang(fr)~.custom-file-label:after{content:\"Parcourir\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48dfd55c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 316
// module chunks = 0